import { Card, CardContent, CardHeader } from "@/components/ui/card.jsx";

/**
 * @param {{ title: string, icon: import("lucide-react").LucideIcon, labels: string[], data: Record<string, unknown>, loading?: boolean }} props
 */
export default function LabelValueCard({
  title,
  icon: Icon,
  labels,
  data,
  loading = false,
}) {
  return (
    <Card className='overflow-hidden rounded-lg border-border bg-card shadow-sm'>
      <CardHeader className='border-b border-border bg-card pb-3'>
        <div className='flex items-center gap-2'>
          <Icon className='h-4 w-4 text-muted-foreground' />
          <span className='font-bold text-foreground'>{title}</span>
        </div>
      </CardHeader>
      <CardContent className='rounded-b-lg bg-card pt-4'>
        <dl className='grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm'>
          {labels.map((label) => {
            const value = data[label];
            const hasValue = value != null && String(value).trim() !== "";
            return (
              <div key={label} className='flex justify-between gap-3'>
                <dt className='text-muted-foreground shrink-0'>{label}</dt>
                <dd className='font-semibold text-foreground text-right min-w-0'>
                  {loading ? (
                    <span
                      className='inline-block h-4 min-w-[3rem] max-w-[8rem] rounded bg-muted animate-pulse'
                      aria-hidden
                    />
                  ) : (
                    <span>{hasValue ? String(value) : "—"}</span>
                  )}
                </dd>
              </div>
            );
          })}
        </dl>
      </CardContent>
    </Card>
  );
}
